// extracted by mini-css-extract-plugin
export default {"siteGateHeaderTitle":"l4njHi"};